import gsap from "gsap";

let titleSequence =promokit.sequence({
    el: '.main__title',
    path: promokit.store('staticPath') + '/promo/aion/history/2021/210203_update/img/pc/main/sq',
    prefix: 'title_',
    frame: 120,
    loop: true,
    preload: true,
    autoplay: true,
    fps: 30
});

let introBgVideo = promokit.video({
    el: '.video-intro',
    url: 'https://vod.plaync.com/Aion/update/210128/aion_intro.mp4',
    loop: false,
    preload: true,
    resizeTarget: 'window'
});

let loopBgVideo = promokit.video({
    el: '.video-loop',
    url: 'https://vod.plaync.com/Aion/update/210128/aion_intro_loop.mp4',
    loop: true,
    preload: true,
    resizeTarget: 'window'
});

let videoId = introBgVideo;
let isFirst = true;

$('.video-loop').addClass('promokit-bg-player').hide();

introBgVideo.on("ended", ()=>{
    videoId = loopBgVideo;
    loopBgVideo.play();
    $('.video-intro').fadeOut();
    $('.video-loop').show();
})




const intiAni = gsap.timeline({paused:true})
    .addLabel('start')
    .from(".promokit-fullpage-menu", 0.9, {x:200, autoAlpha:0, ease:"Power1.easeOut", onComplete: function() {
        $(".promokit-fullpage-menu").addClass('active')
        }}, "start+=0.0")
    .from(".main__title", 0.9, {scale: 0.9,autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.3")
    .add(function(){
        titleSequence.play();
    }, "start+=1.5")
    .from(".main__icon", 0.9, {scale:0.5, autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.3")
    .staggerFrom('.main__banner li', 0.6, {y: 120, opacity:0,ease: "Power1.easeOut",}, 0.1, 'start+=2.5')
    .from(".main__scroll", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=3.0")
    .from('.main__util', 0.9, {autoAlpha:0, ease:"Power1.easeOut"}, "start+=3.5",)

export default {
    id: '#main',
    name: 'Main',
    backgroundVideo:videoId,
    enterStart() {
        // intiAni.seek(0);
        intiAni.play();
        if(!isFirst){
            introBgVideo.stop();
        }
    },
    enterEnd(){


    },
    leaveStart() {

    },
    leaveEnd(){
        if(isFirst){
            $('.video-loop').addClass('promokit-bg-player');
            $('.video-intro').fadeOut();
            $('.video-loop').show();
            isFirst =  false;
        }
    }
};



// WEBPACK FOOTER //
// ./src/js/page/main.js